<div class="ic-button-view-all">
  <button class="button-view-all ic-btn-primary" [routerLink]="toRedirect">
    <span>{{ label }}</span>
  </button>
</div>
